module.exports = __webpack_public_path__ + "img/auctionsplus_alt.b9b27d743462afd2e90fa69bc2fa3ae5.svg";